import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const StatusText = (props) => {
	const { lines = [] } = props;

	return (
		<Box>
			{lines.length > 0 && (
				<Stack>
					{lines.map((line) => (
						<Stack direction="row" flexWrap="wrap" gap={1} key={line.id}>
							{line.text && (
								<Typography
									color={line.muted ? 'text.secondary' : undefined}
								>
									{line.text}
								</Typography>
							)}
							{line.cross && (
								<Typography
									color="text.secondary"
									sx={{ textDecoration: 'line-through' }}
								>
									{line.cross}
								</Typography>
							)}
						</Stack>
					))}
				</Stack>
			)}
		</Box>
	);
};

StatusText.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	lines: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string,
			cross: PropTypes.string,
			muted: PropTypes.bool,
		}),
	),
};

export default StatusText;
